// resources/js/src/components/community/components/post/PostActions.tsx
import { useState } from "react";
import PostReactions from "./PostReactions";
import { Icon } from "@iconify/react";
import { ReactionType } from "../interfaces/types";
import ShareButton from "../../share/ShareButton";
import PostComments from "../../comments/PostComments";
import { useAuthStore } from "../../../../../auth/auth.store";

type Props = {
  postId: number | string;
  reaction: ReactionType;
  onReact: (r: ReactionType) => void;
};

const PostActions: React.FC<Props> = ({ postId, reaction, onReact }) => {
  const [showComments, setShowComments] = useState(false);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  const handleReact = (r: ReactionType) => {
    if (!isAuthenticated) return;
    onReact(r);
  };

  return (
    <>
      <div className="flex justify-around border-t pt-2 text-sm">
        {isAuthenticated ? (
          <PostReactions reaction={reaction} onReact={handleReact} />
        ) : (
          <span className="opacity-50 pointer-events-none px-4 py-2">
            <PostReactions reaction={reaction} onReact={() => {}} />
          </span>
        )}

        <button
          onClick={() => setShowComments((v) => !v)}
          className="px-4 py-2 rounded-full hover:bg-charcoalGray/10 dark:hover:bg-deepSlate cursor-pointer"
        >
          <Icon icon="mdi:message-outline" className="w-5 h-5 inline mr-1" /> Comment
        </button>

        <ShareButton />
      </div>

      {showComments && <PostComments postId={postId} />}
    </>
  );
};

export default PostActions;